module.exports = __webpack_public_path__ + "static/roche-press-day-4-ad3c39d803e4c85d96508e5ee7ce519b.jpg";